import { render, staticRenderFns } from "./webContent.vue?vue&type=template&id=b3f98194&scoped=true&"
import script from "./webContent.vue?vue&type=script&lang=js&"
export * from "./webContent.vue?vue&type=script&lang=js&"
import style0 from "./webContent.vue?vue&type=style&index=0&id=b3f98194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f98194",
  null
  
)

export default component.exports